import * as types from '@/store/types'

export default {
    methods: {
        openGlobalAlert: function (message, color) {
            this.$store.commit(types.SHOW_GLOBAL_ALERT, {
                value: true,
                message: message,
                color: color
            })
        },
        openGlobalLoader: function (message) {
            this.$store.commit(types.SHOW_GLOBAL_LOADER, {
                value: true,
                message: message
            })
        },
        closeGlobalLoader: function () {
            this.$store.commit(types.SHOW_GLOBAL_LOADER, {
                value: false,
                message: ''
            })
        }
    }
}